<app-form-variant-selector
  [variants]="variants"
  [selectedVariantGuid]="selectedVariantGuid"
  [formGuid]="formGuid"
  [disabled]="update"
  [pinned]="variantPinned"
  (variantChange)="onVariantSelectionChange($event)">
</app-form-variant-selector>

<ng-container *ngIf="!awaitingVariantSelection">
<div
  *ngFor="
    let detailGroupInfoLists of pageData.detailGroupInfoListsArray;
    let formIndex = index;
    let isFirstForm = first;
    let isLastForm = last
  "
>
  <aw-wizard
    [navBarLayout]="'large-empty-symbols'"
    class="tabgreen"
    [class.no-step-header]="detailGroupInfoLists.length === 1"
    [hidden]="formIndex !== currentFormIndex"
  >
    <aw-wizard-step
      [canExit]="canExit.bind(this)"
      *ngFor="
        let questionGroupListItem of detailGroupInfoLists;
        let i = index;
        let isFirst = first;
        let isLast = last
      "
    >
      <form [formGroup]="pageData.formGroupLists[formIndex][i]">
        <ng-template awWizardStepSymbol>{{ i + 1 }} </ng-template>
        <app-detail-info-form-page-step
          [form]="pageData.formGroupLists[formIndex][i]"
          [detailGroupInfoList]="questionGroupListItem"
        >
        </app-detail-info-form-page-step>
        <ng-container *ngIf="isLast && isLastForm">
          <ng-content select="[extraFields]"></ng-content>
          <ng-content select="[recaptcha]"></ng-content>
        </ng-container>
        <ng-container *ngIf="errors.length">
          <div class="mb-2 alert alert-danger">
            * Form has {{ errors.length }} validation error(s).
          </div>
        </ng-container>
      </form>
      <div align="end" class="me-3 d-flex align-items-center">
        <div class="me-auto">
          <button
            *ngIf="!update && showReset && !readOnly"
            type="button"
            class="btn btn-outline-secondary"
            (click)="reset()"
            [disabled]="processing$ | async"
            awResetWizard
          >
            Reset
          </button>
        </div>
        <div *ngIf="update || readOnly" class="me-auto"></div>
        <button
          *ngIf="isLast && isLastForm && !readOnly"
          type="button"
          class="btn btn-success mx-1"
          (click)="submit()"
          [disabled]="processing$ | async"
        >
          <!-- Bulk saves can take seconds; without visible feedback a disabled form reads
               as a frozen app. -->
          <ng-container *ngIf="processing$ | async; else saveLabel">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Saving…
          </ng-container>
          <ng-template #saveLabel>{{ saveText }}</ng-template>
        </button>
        <button
          *ngIf="isLast && isLastForm && !readOnly && showSaveAndNew"
          type="button"
          class="btn btn-success mx-1"
          (click)="submit(true)"
          [disabled]="processing$ | async"
        >
          <ng-container *ngIf="processing$ | async; else saveAndNewText">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Saving…
          </ng-container>
          <ng-template #saveAndNewText>Save &amp; add another</ng-template>
        </button>
        <button
          *ngIf="isLast && !isLastForm && !readOnly"
          type="button"
          class="btn btn-success mx-1"
          (click)="nextForm()"
        >
          Next Form
        </button>
        <button
          *ngIf="!isLast && !readOnly"
          type="button"
          class="btn btn-success mx-1"
          (click)="next()"
          awNextStep
        >
          Next
        </button>
        <button
          *ngIf="!isFirst && !readOnly"
          type="button"
          class="btn btn-outline-secondary mx-1"
          (click)="back()"
          awPreviousStep
        >
          Back
        </button>
        <button
          *ngIf="isFirst && !isFirstForm && !readOnly"
          type="button"
          class="btn btn-outline-secondary mx-1"
          (click)="previousForm()"
        >
          Previous Form
        </button>
        <button
          *ngIf="showCancel"
          type="button"
          class="btn btn-outline-secondary mx-1"
          (click)="closeDialog(false)"
        >
          {{ cancelText }}
        </button>
      </div>
    </aw-wizard-step>
  </aw-wizard>
</div>
</ng-container>
